<p>general-cotizaciones works!</p>
<app-breadcrumb [title]="'Cerradas'" [items]="['Comercial', 'Cotizaciones']" [active_item]="'Cerradas'"></app-breadcrumb>
<div class="container-fluid">
  <div class="card">
    <div class="card-header d-flex align-items-center bg-primary text-white">
      <i class="icofont icofont-verification-check me-2"></i>
      <h5 class="mb-0">Listados Cerrados Cotizaciones</h5>
    </div>
    <div class="card-body custom-datatable noscroll">
      <div class="row mb-3">
        <div class="col-4 offset-8">
          <div class="input-group">
            <input
                type="text"
                class="form-control"
                placeholder="Buscar por nombre"
                [(ngModel)]="searchText"
                (input)="filterByMultipleFields()"
              />
            <span class="input-group-text">
              <i class="fa fa-search"></i> <!-- Icono de búsqueda -->
            </span>
          </div>
        </div>
      </div>
      <div class="custom-datatable table-responsive">
        <table class="table table-responsive  border border-secondary  table-hover table-striped my-3 " >
          <thead>
            <tr>
                <th scope="col" sortable="NumeroCotizacion" (sort)="onSort($event)" class="text-primary border border-secondary text-center" style="min-width: 80px;">NÚMERO COTIZACION</th>
                <th scope="col" sortable="Fecha" (sort)="onSort($event)" class="text-primary border border-secondary text-center" style="min-width: 80px;">FECHA</th>
                <th scope="col" sortable="Documento" (sort)="onSort($event)" class="text-primary border border-secondary text-center" style="min-width: 80px;">DOCUMENTO</th>
                <th scope="col" sortable="Cliente" (sort)="onSort($event)" class="text-primary border border-secondary text-center" style="min-width: 80px;">CLIENTE</th>
                <th scope="col" sortable="Direccion" (sort)="onSort($event)" class="text-primary border border-secondary text-center" style="min-width: 120px;">DIRECCIÓN</th>
                <th scope="col" sortable="Telefono" (sort)="onSort($event)" class="text-primary border border-secondary text-center" style="min-width: 120px;">TELÉFONO</th>
                <th scope="col" sortable="Email" (sort)="onSort($event)" class="text-primary border border-secondary text-center" style="min-width: 230px;">E-MAIL</th>
                <th scope="col" sortable="Vrtotal" (sort)="onSort($event)" class="text-primary border border-secondary text-center">VR TOTAL</th>
                <th scope="col" sortable="Estado" (sort)="onSort($event)" class="text-primary border border-secondary text-center">ESTADO</th>  
              </tr>
              
          </thead>
          <tbody>
            <tr *ngFor="let item of filteredTableItems">
              <td class="border border-secondary">
                <ngb-highlight [result]="item.NumeroCotizacion" [term]="service.searchTerm"></ngb-highlight>
              </td>
              <td class="border border-secondary">
                <ngb-highlight [result]="item.Fecha" [term]="service.searchTerm"></ngb-highlight>
              </td>
              <td class="border border-secondary">
                <ngb-highlight [result]="item.Documento" [term]="service.searchTerm"></ngb-highlight>
              </td>
              <td class="border border-secondary">
                <ngb-highlight [result]="item.Cliente" [term]="service.searchTerm"></ngb-highlight>
              </td>
              <td class="border border-secondary">
                <ngb-highlight [result]="item.Direccion" [term]="service.searchTerm"></ngb-highlight>
              </td>
              <td class="border border-secondary">
                <ngb-highlight [result]="item.Telefono" [term]="service.searchTerm"></ngb-highlight>
              </td>
              <td class="border border-secondary">
                <ngb-highlight [result]="item.Email" [term]="service.searchTerm"></ngb-highlight>
              </td>
              <td class="border border-secondary">
                <ngb-highlight [result]="item.Vrtotal" [term]="service.searchTerm"></ngb-highlight>
              </td>
              <td class="border border-secondary">
                <span class="badge {{ item.ActionClass }}">
                  <ngb-highlight [result]="item.Estado" [term]="service.searchTerm"></ngb-highlight>
                </span>
              </td>
              <td class="border border-secondary">
                <div class="action">
                  <li class="edit">
                    <a href="#"><i class="icon-pencil-alt"></i></a>
                  </li>
                  <li class="delete" (click)="onSelect(item.name)">
                    <a href="#"><i class="icon-trash"></i></a>
                  </li>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="d-flex justify-content-between mt-3">
          <select class="form-select" style="width: 150PX" name="pageSize" [(ngModel)]="service.pageSize">
            <option [ngValue]="2">2 items per page</option>
            <option [ngValue]="4">4 items per page</option>
            <option [ngValue]="6">6 items per page</option>
          </select>
          <ngb-pagination class="ms-3" [collectionSize]="(total$ | async)!" [(page)]="service.page" [pageSize]="service.pageSize"> </ngb-pagination>
        </div>
      </div>
    </div>
  </div>
</div>